/**
 * @generated SignedSource<<689415aed0ce0c01388eb1520ba4fde4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CsvExportQueryTypeEnum = "CATALOG" | "HUB" | "HUB_PAGE" | "ZNGLIST";
export type MetaCompareEnum = "BETWEEN" | "EQUAL_TO" | "EXISTS" | "GREATER_THAN" | "GREATER_THAN_OR_EQUAL_TO" | "IN" | "LESS_THAN" | "LESS_THAN_OR_EQUAL_TO" | "LIKE" | "NOT_BETWEEN" | "NOT_EQUAL_TO" | "NOT_EXISTS" | "NOT_IN" | "NOT_LIKE";
export type MetaTypeEnum = "BINARY" | "CHAR" | "DATE" | "DATETIME" | "DECIMAL" | "NUMERIC" | "SIGNED" | "TIME" | "UNSIGNED";
export type PostObjectsConnectionDateColumnEnum = "DATE" | "MODIFIED";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type RelationEnum = "AND" | "OR";
export type CsvExportQueryInput = {
  authorIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  categoryIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  date?: DateQueryInput | null | undefined;
  hubFilter?: string | null | undefined;
  hubGroup?: ReadonlyArray<string | null | undefined> | null | undefined;
  hubTemplate?: ReadonlyArray<string | null | undefined> | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  metaQuery?: MetaQuery | null | undefined;
  queryType: CsvExportQueryTypeEnum;
  search?: string | null | undefined;
  statusIn?: ReadonlyArray<PostStatusEnum | null | undefined> | null | undefined;
};
export type DateQueryInput = {
  after?: DateInput | null | undefined;
  before?: DateInput | null | undefined;
  column?: PostObjectsConnectionDateColumnEnum | null | undefined;
  compare?: string | null | undefined;
  day?: number | null | undefined;
  hour?: number | null | undefined;
  inclusive?: boolean | null | undefined;
  minute?: number | null | undefined;
  month?: number | null | undefined;
  relation?: RelationEnum | null | undefined;
  second?: number | null | undefined;
  week?: number | null | undefined;
  year?: number | null | undefined;
};
export type DateInput = {
  day?: number | null | undefined;
  month?: number | null | undefined;
  year?: number | null | undefined;
};
export type MetaQuery = {
  metaArray?: ReadonlyArray<MetaArray | null | undefined> | null | undefined;
  relation?: RelationEnum | null | undefined;
};
export type MetaArray = {
  compare?: MetaCompareEnum | null | undefined;
  key?: string | null | undefined;
  type?: MetaTypeEnum | null | undefined;
  value?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type Export_Csv_Query$variables = {
  input: CsvExportQueryInput;
};
export type Export_Csv_Query$data = {
  readonly csvExport: {
    readonly csv: string | null | undefined;
  } | null | undefined;
};
export type Export_Csv_Query = {
  response: Export_Csv_Query$data;
  variables: Export_Csv_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CsvExport",
    "kind": "LinkedField",
    "name": "csvExport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "csv",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Export_Csv_Query",
    "selections": (v1/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Export_Csv_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "151832509fa9235cb512e850b8ad3725",
    "id": null,
    "metadata": {},
    "name": "Export_Csv_Query",
    "operationKind": "query",
    "text": "query Export_Csv_Query(\n  $input: CsvExportQueryInput!\n) {\n  csvExport(input: $input) {\n    csv\n  }\n}\n"
  }
};
})();

(node as any).hash = "c7153773406e285bd9c9c60ccd268586";

export default node;
